export const _BRPConflictProps = [
  'noWrap',
  'labelPosition',
  'fullOrInpage',
  'active',
  'vMedia',
  'hMedia',
  'inFocus',
  'multiLine',
  'invalid',
  'register',
  'registerDescriber',
  'fieldSize',
  'inputState',
  'show',
  'maxLines',
  'multiline',
  'lineCount',
  'underline',
  'srOnly',
  'alignLeft',
  'alignCenter',
  'alignRight',
  'alignJustify',
  'displayBlock',
  'gutterBottom',
  'paragraph',
  'sortType',
  'sortSize',
  'listStyleColor',
  'listStyleType',
  'listStylePosition',
  'customIcon',
];
